export default __webpack_public_path__ + "static/media/uses_dark.c848b0bc.png";